import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Fetch } from "../../shared/Fetch";
import RichTextEditor from "../RichEditorText/richEditorText";

const SignatureWrapper = styled.div`
  padding: 1.5rem;
  font-family: 'Metropolis', 'Inter', sans-serif;

  .page-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #23272E;
    margin-bottom: 1.5rem;
  }

  .card_box {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
    max-width: 900px;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .editor-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .label-title {
    font-size: 1rem;
    font-weight: 600;
    color: #23272E;
    display: block;
  }

  .label-desc {
    font-size: 0.875rem;
    color: #8892B0;
    margin-bottom: 0.25rem;
  }

  .editor-wrapper {
    border: 1px solid #E2E8F0;
    border-radius: 8px;
    overflow: hidden;
  }

  .save-btn-container {
    display: flex;
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
  
  .p-button {
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
  }
`;

export const Signature = () => {
  const [signature, setSignature] = useState({
    shortSignature: "",
    fullSignature: "",
  });
  const [loading, setLoading] = useState(false);
  const toastRef = useRef<any>(null);

  const loadSignature = async () => {
    setLoading(true);
    try {
      const res = await Fetch("UserSignature", "GET", null, null, toastRef);
      if (res) {
        const data = await res.json();
        setSignature({
          shortSignature: data.shortSignature || "",
          fullSignature: data.fullSignature || "",
        });
      }
    } catch (err) {
      console.error("Error loading signature:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSignature();
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await Fetch("UserSignature", "PUT", signature, null, toastRef);
      if (res) {
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: "Signature Saved Successfully",
          life: 3000,
        });
        loadSignature();
      }
    } catch (err) {
      console.error("Error saving signature:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignatureWrapper>
      <Toast ref={toastRef} />
      <h2 className="page-title">Email Signature</h2>
      
      <div className="card_box">
        <div className="editor-section">
          <label className="label-title">Short Signature</label>
          <div className="label-desc">Used for quick email replies.</div>
          <div className="editor-wrapper">
            <RichTextEditor
              value={signature.shortSignature}
              height={250}
              onChange={(value) =>
                setSignature((prev) => ({
                  ...prev,
                  shortSignature: value,
                }))
              }
            />
          </div>
        </div>

        <div className="editor-section">
          <label className="label-title">Full Signature</label>
          <div className="label-desc">Used for detailed emails.</div>
          <div className="editor-wrapper">
            <RichTextEditor
              value={signature.fullSignature}
              height={250}
              onChange={(value) =>
                setSignature((prev) => ({
                  ...prev,
                  fullSignature: value,
                }))
              }
            />
          </div>
        </div>

        <div className="save-btn-container">
          <Button
            label="Save Signature"
            icon="pi pi-check"
            loading={loading}
            onClick={handleSave}
            className="p-button-primary"
          />
        </div>
      </div>
    </SignatureWrapper>
  );
};